// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetArticleAuthorFollowersByIdQueryVariables = Types.Exact<{
  articleID: Types.Scalars['SlugOrID']['input'];
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetArticleAuthorFollowersByIdQuery = {
  __typename?: 'Query';
  articlesArticle?: {
    __typename?: 'ArticlesArticle';
    context?:
      | {
          __typename?: 'ContentInsiderPage';
          insiderPageMetadata: {
            __typename?: 'ContentPageMetadata';
            followersWithinContacts?: {
              __typename?: 'ContentPageFollowersWithinContactsConnection';
              total: number;
              edges: Array<{
                __typename?: 'ContentFollowerEdge';
                node: {
                  __typename?: 'ContentFollower';
                  xingId?: {
                    __typename?: 'XingId';
                    displayName: string;
                    pageName: string;
                    gender?: Types.Gender | null;
                    occupations?: Array<{
                      __typename?: 'XingIdOccupation';
                      headline: string;
                      subline: string;
                    } | null> | null;
                    userFlags?: {
                      __typename?: 'UserFlags';
                      displayFlag?: Types.UserFlagsDisplayFlag | null;
                    } | null;
                    profileImage?: Array<{
                      __typename?: 'ProfileImage';
                      url: string;
                    } | null> | null;
                  } | null;
                };
              } | null>;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                endCursor?: string | null;
              };
            } | null;
          };
        }
      | {
          __typename?: 'ContentPage';
          entityPageMetadata?:
            | {
                __typename?: 'ContentManagedPageMetadata';
                followersWithinContacts?: {
                  __typename?: 'ContentPageFollowersWithinContactsConnection';
                  total: number;
                  edges: Array<{
                    __typename?: 'ContentFollowerEdge';
                    node: {
                      __typename?: 'ContentFollower';
                      xingId?: {
                        __typename?: 'XingId';
                        displayName: string;
                        pageName: string;
                        gender?: Types.Gender | null;
                        occupations?: Array<{
                          __typename?: 'XingIdOccupation';
                          headline: string;
                          subline: string;
                        } | null> | null;
                        userFlags?: {
                          __typename?: 'UserFlags';
                          displayFlag?: Types.UserFlagsDisplayFlag | null;
                        } | null;
                        profileImage?: Array<{
                          __typename?: 'ProfileImage';
                          url: string;
                        } | null> | null;
                      } | null;
                    };
                  } | null>;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    endCursor?: string | null;
                  };
                } | null;
              }
            | {
                __typename?: 'ContentPageMetadata';
                followersWithinContacts?: {
                  __typename?: 'ContentPageFollowersWithinContactsConnection';
                  total: number;
                  edges: Array<{
                    __typename?: 'ContentFollowerEdge';
                    node: {
                      __typename?: 'ContentFollower';
                      xingId?: {
                        __typename?: 'XingId';
                        displayName: string;
                        pageName: string;
                        gender?: Types.Gender | null;
                        occupations?: Array<{
                          __typename?: 'XingIdOccupation';
                          headline: string;
                          subline: string;
                        } | null> | null;
                        userFlags?: {
                          __typename?: 'UserFlags';
                          displayFlag?: Types.UserFlagsDisplayFlag | null;
                        } | null;
                        profileImage?: Array<{
                          __typename?: 'ProfileImage';
                          url: string;
                        } | null> | null;
                      } | null;
                    };
                  } | null>;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    endCursor?: string | null;
                  };
                } | null;
              }
            | null;
        }
      | null;
  } | null;
};

export type ArticleAuthorFollowerContext_ContentInsiderPage_Fragment = {
  __typename?: 'ContentInsiderPage';
  insiderPageMetadata: {
    __typename?: 'ContentPageMetadata';
    followersWithinContacts?: {
      __typename?: 'ContentPageFollowersWithinContactsConnection';
      total: number;
      edges: Array<{
        __typename?: 'ContentFollowerEdge';
        node: {
          __typename?: 'ContentFollower';
          xingId?: {
            __typename?: 'XingId';
            displayName: string;
            pageName: string;
            gender?: Types.Gender | null;
            occupations?: Array<{
              __typename?: 'XingIdOccupation';
              headline: string;
              subline: string;
            } | null> | null;
            userFlags?: {
              __typename?: 'UserFlags';
              displayFlag?: Types.UserFlagsDisplayFlag | null;
            } | null;
            profileImage?: Array<{
              __typename?: 'ProfileImage';
              url: string;
            } | null> | null;
          } | null;
        };
      } | null>;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        endCursor?: string | null;
      };
    } | null;
  };
};

export type ArticleAuthorFollowerContext_ContentPage_Fragment = {
  __typename?: 'ContentPage';
  entityPageMetadata?:
    | {
        __typename?: 'ContentManagedPageMetadata';
        followersWithinContacts?: {
          __typename?: 'ContentPageFollowersWithinContactsConnection';
          total: number;
          edges: Array<{
            __typename?: 'ContentFollowerEdge';
            node: {
              __typename?: 'ContentFollower';
              xingId?: {
                __typename?: 'XingId';
                displayName: string;
                pageName: string;
                gender?: Types.Gender | null;
                occupations?: Array<{
                  __typename?: 'XingIdOccupation';
                  headline: string;
                  subline: string;
                } | null> | null;
                userFlags?: {
                  __typename?: 'UserFlags';
                  displayFlag?: Types.UserFlagsDisplayFlag | null;
                } | null;
                profileImage?: Array<{
                  __typename?: 'ProfileImage';
                  url: string;
                } | null> | null;
              } | null;
            };
          } | null>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
          };
        } | null;
      }
    | {
        __typename?: 'ContentPageMetadata';
        followersWithinContacts?: {
          __typename?: 'ContentPageFollowersWithinContactsConnection';
          total: number;
          edges: Array<{
            __typename?: 'ContentFollowerEdge';
            node: {
              __typename?: 'ContentFollower';
              xingId?: {
                __typename?: 'XingId';
                displayName: string;
                pageName: string;
                gender?: Types.Gender | null;
                occupations?: Array<{
                  __typename?: 'XingIdOccupation';
                  headline: string;
                  subline: string;
                } | null> | null;
                userFlags?: {
                  __typename?: 'UserFlags';
                  displayFlag?: Types.UserFlagsDisplayFlag | null;
                } | null;
                profileImage?: Array<{
                  __typename?: 'ProfileImage';
                  url: string;
                } | null> | null;
              } | null;
            };
          } | null>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
          };
        } | null;
      }
    | null;
};

export type ArticleAuthorFollowerContextFragment =
  | ArticleAuthorFollowerContext_ContentInsiderPage_Fragment
  | ArticleAuthorFollowerContext_ContentPage_Fragment;

export type ArticleAuthorFollowersWithinContactsFragment = {
  __typename?: 'ContentPageFollowersWithinContactsConnection';
  total: number;
  edges: Array<{
    __typename?: 'ContentFollowerEdge';
    node: {
      __typename?: 'ContentFollower';
      xingId?: {
        __typename?: 'XingId';
        displayName: string;
        pageName: string;
        gender?: Types.Gender | null;
        occupations?: Array<{
          __typename?: 'XingIdOccupation';
          headline: string;
          subline: string;
        } | null> | null;
        userFlags?: {
          __typename?: 'UserFlags';
          displayFlag?: Types.UserFlagsDisplayFlag | null;
        } | null;
        profileImage?: Array<{
          __typename?: 'ProfileImage';
          url: string;
        } | null> | null;
      } | null;
    };
  } | null>;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    endCursor?: string | null;
  };
};

export type ArticleAuthorFollowerFragment = {
  __typename?: 'ContentFollowerEdge';
  node: {
    __typename?: 'ContentFollower';
    xingId?: {
      __typename?: 'XingId';
      displayName: string;
      pageName: string;
      gender?: Types.Gender | null;
      occupations?: Array<{
        __typename?: 'XingIdOccupation';
        headline: string;
        subline: string;
      } | null> | null;
      userFlags?: {
        __typename?: 'UserFlags';
        displayFlag?: Types.UserFlagsDisplayFlag | null;
      } | null;
      profileImage?: Array<{
        __typename?: 'ProfileImage';
        url: string;
      } | null> | null;
    } | null;
  };
};

export type ArticleAuthorFollowersPageInfoFragment = {
  __typename?: 'PageInfo';
  hasNextPage: boolean;
  endCursor?: string | null;
};

export const ArticleAuthorFollowerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollower' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentFollowerEdge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xingId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headline' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subline' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userFlags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayFlag' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'EnumValue', value: 'SQUARE_256' },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleAuthorFollowerFragment, unknown>;
export const ArticleAuthorFollowersPageInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollowersPageInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleAuthorFollowersPageInfoFragment, unknown>;
export const ArticleAuthorFollowersWithinContactsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollowersWithinContacts' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'ContentPageFollowersWithinContactsConnection',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ArticleAuthorFollower' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'ArticleAuthorFollowersPageInfo',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollower' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentFollowerEdge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xingId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headline' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subline' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userFlags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayFlag' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'EnumValue', value: 'SQUARE_256' },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollowersPageInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArticleAuthorFollowersWithinContactsFragment,
  unknown
>;
export const ArticleAuthorFollowerContextFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleAuthorFollowerContext' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesContextInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentInsiderPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'insiderPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'first' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'after' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'after' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ArticleAuthorFollowersWithinContacts',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'entityPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'first' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'after' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'after' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ArticleAuthorFollowersWithinContacts',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollower' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentFollowerEdge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xingId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headline' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subline' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userFlags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayFlag' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'EnumValue', value: 'SQUARE_256' },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollowersPageInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollowersWithinContacts' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'ContentPageFollowersWithinContactsConnection',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ArticleAuthorFollower' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'ArticleAuthorFollowersPageInfo',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleAuthorFollowerContextFragment, unknown>;
export const GetArticleAuthorFollowersByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArticleAuthorFollowersById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'articleID' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articlesArticle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'articleID' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'context' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'articleAuthorFollowerContext',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollower' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentFollowerEdge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xingId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headline' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subline' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userFlags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayFlag' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'EnumValue', value: 'SQUARE_256' },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollowersPageInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleAuthorFollowersWithinContacts' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'ContentPageFollowersWithinContactsConnection',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ArticleAuthorFollower' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'ArticleAuthorFollowersPageInfo',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleAuthorFollowerContext' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesContextInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentInsiderPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'insiderPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'first' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'after' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'after' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ArticleAuthorFollowersWithinContacts',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'entityPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'first' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'after' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'after' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ArticleAuthorFollowersWithinContacts',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetArticleAuthorFollowersByIdQuery,
  GetArticleAuthorFollowersByIdQueryVariables
>;
